"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const creatable_1 = __importDefault(require("react-select/creatable"));
const FormControls_1 = __importDefault(require("../controls/FormControls"));
const MaterialTextField_1 = __importDefault(require("../inputs/MaterialTextField"));
exports.default = (0, mobx_react_1.observer)(({ form }) => (react_1.default.createElement("form", null,
    react_1.default.createElement("h2", { className: "light-red" }, "Dynamic Fields Select"),
    react_1.default.createElement("h5", null, "Select or type new options (then press enter) to add new fields:"),
    react_1.default.createElement(creatable_1.default, Object.assign({ isMulti: true, allowCreate: true, resetValue: [], options: form.$('fieldFactory').extra, openOnFocus: false, placeholder: "Type to add fields", noResultsText: "Type to add fields" }, form.$('fieldFactory').bind())),
    react_1.default.createElement("br", null),
    react_1.default.createElement("br", null),
    react_1.default.createElement("h4", null, form.$('dynamicFields').label),
    react_1.default.createElement("hr", null),
    form.$('dynamicFields').map(field => react_1.default.createElement(MaterialTextField_1.default, { key: field.name, field: field })),
    react_1.default.createElement(FormControls_1.default, { form: form }))));
